import Button from '@atlaskit/button/new';
import CopyIcon from '@atlaskit/icon/core/copy';
import { Flex } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { Text } from '@atlassian/learning-components';
import { css } from '@compiled/react';
import { ReactNode } from 'react';

import { useCopyToClipboard } from 'src/hooks/useCopyToClipboard';

interface Props {
  icon: ReactNode;
  label: string;
  value?: string;
  copyButtonLabel?: string;
}

export const ContactInfo = ({ icon, label, value, copyButtonLabel }: Props) => {
  const { copyToClipboard, isCopied } = useCopyToClipboard();

  const handleCopy = () => {
    if (value) {
      copyToClipboard(value);
    }
  };

  return (
    <div css={containerStyles}>
      <Flex alignItems="center" gap="space.150">
        <div css={iconContainerStyles}>{icon}</div>
        <div css={linkContainerStyles}>
          <Text size="small" color={token('color.text.subtle')}>
            {label}
          </Text>
          <p css={valueStyles}>{value}</p>
        </div>
      </Flex>
      {copyButtonLabel && (
        <div css={buttonContainerStyles}>
          <Button
            iconAfter={(iconProps) => <CopyIcon {...iconProps} label="" LEGACY_size="small" />}
            appearance="subtle"
            onClick={handleCopy}
          >
            {isCopied ? 'Copied!' : copyButtonLabel}
          </Button>
        </div>
      )}
    </div>
  );
};

const containerStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: token('space.150'),

  '&:hover > div:last-child': {
    opacity: 1,
    visibility: 'visible',
  },
});

const buttonContainerStyles = css({
  opacity: 0,
  visibility: 'hidden',
  transition: 'opacity 0.2s ease, visibility 0.2s ease',
});

const linkContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});

const iconContainerStyles = css({
  display: 'flex',
  padding: '0.75rem',
  alignItems: 'center',
  gap: token('space.300'),
  borderRadius: '8px',
  // having trouble finding a token with the correct color for the background
  background: '#F8F8F8',
});

const valueStyles = css({
  color: token('color.text.brand'),
  textAlign: 'center',
  fontFamily: 'Charlie Text',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '1.25rem',
  margin: 0,
});
